import React from 'react';
import { WrapContainer } from '../styles';
import { Block } from '../..';
import closeIcon from '../../../../assets/icons/icon-close-red.svg';

const Container = (props: any) => {
  const { handleClose, children, buttonClose, backgroundColor } = props;
  return (
    <WrapContainer backgroundColor={backgroundColor}>
      {buttonClose ? (
        <Block className="icon" onClick={handleClose}>
          {/* <Icon name="x" size={28} /> */}
          <img src={closeIcon} alt="other" />
        </Block>
      ) : (
        <></>
      )}
      {children}
    </WrapContainer>
  );
};

export default Container;
